import { EnvelopeDetailsReport } from '../../types';
import { commonColProps, DataGridHandler } from '../DataGridFlexSales';

export interface EnvelopeDetailsReportDataGridContext {
  t: (key: string | string[]) => string;
  country: string;
}

const initialContext: EnvelopeDetailsReportDataGridContext = {
  t: () => '',
  country: '',
};

export default (locale: Locale) => {
  const handler = new DataGridHandler<EnvelopeDetailsReport, EnvelopeDetailsReportDataGridContext>(
    initialContext,
    locale
  );
  handler.addColumn({
    accessor: 'country',
    type: 'string',
    title: ({ t }) => t('table.columns.country'),
    ...commonColProps.country,
  });

  handler.addColumn({
    accessor: 'store',
    type: 'string',
    title: ({ t, country }) => t([`table.columns.${country}.store`, 'table.columns.store']),
  });

  handler.addColumn({
    accessor: 'businessDate',
    type: 'date',
    title: ({ t }) => t('table.columns.business_date'),
  });

  handler.addColumn({
    accessor: 'pos',
    type: 'string',
    title: ({ t }) => t('table.columns.pos_num'),
  });

  handler.addColumn({
    accessor: 'envelope',
    type: 'string',
    title: ({ t }) => t('envelope-details-report.columns.envelope'),
    width: { px: 100, pt: 100 },
  });

  handler.addColumn({
    accessor: 'movementType',
    type: 'string',
    title: ({ t }) => t('cash-movement-report.columns.movement_type'),
  });

  handler.addColumn({
    accessor: 'referenceNumber',
    type: 'number',
    title: ({ t }) => t('cash-movement-report.columns.reference_number'),
  });

  handler.addColumn({
    accessor: 'movementNumber',
    type: 'number',
    title: ({ t }) => t('cash-movement-report.columns.movement_number'),
  });

  handler.addColumn({
    accessor: 'paymentTypeId',
    type: 'string',
    title: ({ t }) => t('table.columns.payment_type_id'),
  });

  handler.addColumn({
    accessor: 'paymentType',
    type: 'string',
    title: ({ t }) => t('table.columns.payment_type'),
  });

  handler.addColumn({
    accessor: 'movementHour',
    type: 'string',
    title: ({ t }) => t('envelope-details-report.columns.movement_hour'),
  });

  handler.addColumn({
    accessor: 'shiftNum',
    type: 'number',
    title: ({ t }) => t('petty-cash-difference.columns.shift_num'),
  });

  handler.addColumn({
    accessor: 'employeeId',
    type: 'string',
    title: ({ t }) => t('table.columns.operator_id'),
  });

  handler.addColumn({
    accessor: 'employeeName',
    type: 'string',
    title: ({ t }) => t('petty-cash-difference.columns.employee_name'),
  });

  handler.addColumn({
    accessor: 'userId',
    type: 'string',
    title: ({ t }) => t('cash-movement-report.columns.user_id'),
  });

  handler.addColumn({
    accessor: 'userName',
    type: 'string',
    title: ({ t }) => t('cash-movement-report.columns.user_name'),
  });

  handler.addColumn({
    accessor: 'movementAmount',
    type: 'number',
    title: ({ t }) => t('table.columns.theorical_balance_reca'),
  });

  return handler;
};
